import { encodeParam } from "./ApiHelper";

export const getCreateWorkOrderRoute = (
  isRequester: boolean,
  equipmentId: string
) => {
  if (isRequester) {
    return `/requester/create-request/equipment/${encodeParam(
      equipmentId
    )}/create`;
  }
  return `/quick-work-order/equipment/${encodeParam(equipmentId)}/create`;
};

export const getOpenWorkOrdersRoute = (
  isRequester: boolean,
  equipmentId: string
) => {
  if (isRequester) {
    return `/requester/create-request/equipment/${encodeParam(equipmentId)}`;
  }
  return `/quick-work-order/equipment/${encodeParam(equipmentId)}`;
};
